import { styled } from '@mui/system';
import { Stepper, Step } from '@mui/material';

export const Cnt = styled('div')(({ theme }) => ({
  padding: theme.spacing(),
  marginTop: theme.spacing(),
  maxWidth: '700px',
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3),
    marginTop: theme.spacing(3)
  }
}));

export const StyledStepper = styled(Stepper)({
  backgroundColor: 'inherit'
});

export const StyledStep = styled(Step)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    padding: 0
  }
}));
